import { WeekDay } from './WeekDay';

export enum OpeningHoursType {
  WORKING_DAYS = 'WORKING_DAYS',
  CUSTOM = 'CUSTOM',
  UNKNOWN = 'UNKNOWN',
}

export interface OpeningHoursPerWeekDay {
  weekday: WeekDay;
  from: string;
  to: string;
}

export interface OpeningHours {
  openingHoursType: OpeningHoursType; // timeWindowType: LocationTimeWindowType;
  openingHoursPerWeekDay: OpeningHoursPerWeekDay[]; // timeWindows: TimeWindow[];
  timezone: string; // timezone: string;
}

export const DEFAULT_OPENING_HOURS_TIMEZONE = 'UTC';

// NOTE: can be refactored like that: openingHours: OpeningHours[], no need type
// export interface OpeningHours {
//   weekday: WeekDay;
//   from: Date; // 1970-1-1T10:00.00Z (but we care only about time and timezone)
//   to: Date;
// }
